import { takeLatest, put, select } from 'redux-saga/effects';
import { generativeAi as genAiApis } from '../../../../api';
import { apiSaga } from '../../../../root-sagas';

const selectMetadata = state => state.generativeAi.partnerSettings.metadata;
const selectLlmState = state => state.generativeAi.partnerSettings.llmSettings;

function* initialize() {
  const { toolId } = yield select(selectMetadata);
  if (!toolId) return;
  const { providersLoaded, loadingProviders } = yield select(selectLlmState);
  if (!providersLoaded && !loadingProviders) {
    yield put({ type: 'genAI_llmSettings_getProviders' });
  }
  yield put({ type: 'genAI_llmSettings_getConfig' });
}

function* fetchProviders() {
  const { providersLoaded, loadingProviders } = yield select(selectLlmState);
  if (providersLoaded || loadingProviders) return;
  yield apiSaga('genAI_llmSettings_getProviders', genAiApis.getLLMProviders, []);
}

function* fetchConfig() {
  const { toolId, partnerId } = yield select(selectMetadata);
  if (!toolId) return;
  yield apiSaga('genAI_llmSettings_getConfig', genAiApis.getLLMConfig, [{ toolId, partnerId }]);
}

function* saveConfig() {
  const { toolId, partnerId } = yield select(selectMetadata);
  const {
    selectedProvider,
    selectedModel,
    inheritCompanyDefaults,
    initialSelection,
  } = yield select(selectLlmState);
  if (!toolId) return;
  const payload = { toolId }; // partnerId optional
  if (partnerId) {
    payload.partnerId = partnerId;
  }
  if (partnerId && inheritCompanyDefaults) {
    // Only send inherit flag if toggled on or off compared to baseline
    if (!initialSelection.inheritCompanyDefaults) {
      payload.inheritCompanySettings = true;
    } else {
      // nothing to save if still inheriting and baseline also inherited
      yield put({ type: 'genAI_llmSettings_getConfig' });
      return;
    }
  } else {
    payload.llm = selectedProvider;
    payload.model = selectedModel;
  }
  yield apiSaga('genAI_llmSettings_saveConfig', genAiApis.saveLLMConfig, [payload]);
}

const llmSettingsSagas = [
  takeLatest('genAI_llmSettings_initialize', initialize),
  takeLatest('genAI_llmSettings_getProviders', fetchProviders),
  takeLatest('genAI_llmSettings_getConfig', fetchConfig),
  takeLatest('genAI_llmSettings_saveConfig', saveConfig),
];

export default llmSettingsSagas;
